var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { AppConstant } from 'constants/app.constant';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import { courseActions, coursesReducer } from 'reports/cw/redux/ducks/courses';
import { cwActions, cwReducer } from 'reports/cw/redux/ducks/cw';
import { dpActions, dpReducer } from 'reports/dp/redux/ducks/dp';
import { ehrActions, ehrReducer } from 'reports/ehr/redux/ducks/ehr';
import { HAD_PATHS } from 'reports/had/constants/had.constant';
import { hadActions, hadReducer } from 'reports/had/redux/ducks/had';
import { hesiNgActions, hesiNgReducer } from 'reports/hesi-ng/redux/ducks/hesi-ng';
import { psActions, psReducer } from 'reports/ps/redux/ducks/ps';
import { SH_PATHS } from 'reports/sh/constants/sh.constant';
import { shActions, shReducer } from 'reports/sh/redux/ducks/sh';
import { addUpdateData, getData } from '../indexedDB/db';
import { appActions, appReducer } from './ducks/app';
import { filterActions, filterReducer } from './ducks/filter';
import { languageReducer } from './ducks/language';
import { routeReducer } from './ducks/route';
import { toastReducer } from './ducks/toast';
export var handleDataRestore = function (store) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve) {
                (function () { return __awaiter(void 0, void 0, void 0, function () {
                    var actionState, rootStateFromStorage, cwState, appState, hadState, ehrState, courseState, filterState, shState, psState, hesiNGState, dpState, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 13, , 14]);
                                return [4 /*yield*/, getData()];
                            case 1:
                                actionState = _a.sent();
                                if (!(actionState === null || actionState === void 0 ? void 0 : actionState.value)) {
                                    // No record found in indexedDB
                                    resolve();
                                    return [2 /*return*/];
                                }
                                rootStateFromStorage = actionState.value;
                                cwState = rootStateFromStorage[AppConstant.reduxResources.CW_STATE];
                                appState = rootStateFromStorage[AppConstant.reduxResources.APP_STATE];
                                hadState = rootStateFromStorage[AppConstant.reduxResources.HAD_STATE];
                                ehrState = rootStateFromStorage[AppConstant.reduxResources.EHR_STATE];
                                courseState = rootStateFromStorage[AppConstant.reduxResources.COURSES_STATE];
                                filterState = rootStateFromStorage[AppConstant.reduxResources.FILTER_STATE];
                                shState = rootStateFromStorage[AppConstant.reduxResources.SH_STATE];
                                psState = rootStateFromStorage[AppConstant.reduxResources.PS_STATE];
                                hesiNGState = rootStateFromStorage[AppConstant.reduxResources.HESI_NG_STATE];
                                dpState = rootStateFromStorage[AppConstant.reduxResources.DP_STATE];
                                if (!appState) return [3 /*break*/, 12];
                                return [4 /*yield*/, store.dispatch(cwActions.restoreState(cwState))];
                            case 2:
                                _a.sent();
                                return [4 /*yield*/, store.dispatch(appActions.restoreState(appState))];
                            case 3:
                                _a.sent();
                                return [4 /*yield*/, store.dispatch(hadActions.restoreState(hadState))];
                            case 4:
                                _a.sent();
                                return [4 /*yield*/, store.dispatch(ehrActions.restoreState(ehrState))];
                            case 5:
                                _a.sent();
                                return [4 /*yield*/, store.dispatch(courseActions.restoreState(courseState))];
                            case 6:
                                _a.sent();
                                return [4 /*yield*/, store.dispatch(filterActions.restoreState(filterState))];
                            case 7:
                                _a.sent();
                                return [4 /*yield*/, store.dispatch(shActions.restoreState(shState))];
                            case 8:
                                _a.sent();
                                return [4 /*yield*/, store.dispatch(psActions.restoreState(psState))];
                            case 9:
                                _a.sent();
                                return [4 /*yield*/, store.dispatch(hesiNgActions.restoreState(hesiNGState))];
                            case 10:
                                _a.sent();
                                return [4 /*yield*/, store.dispatch(dpActions.restoreState(dpState))];
                            case 11:
                                _a.sent();
                                _a.label = 12;
                            case 12:
                                resolve();
                                return [3 /*break*/, 14];
                            case 13:
                                error_1 = _a.sent();
                                // Resolve the promise even if there is an error to prevent the app from blocking the UI
                                resolve();
                                return [3 /*break*/, 14];
                            case 14: return [2 /*return*/];
                        }
                    });
                }); })();
            })];
    });
}); };
var createDefaultReducers = function (history) {
    var _a;
    return combineReducers(__assign(__assign({}, routeReducer), (_a = {}, _a[AppConstant.reduxResources.ROUTER] = connectRouter(history), _a[AppConstant.reduxResources.APP_STATE] = appReducer, _a[AppConstant.reduxResources.FILTER_STATE] = filterReducer, _a[AppConstant.reduxResources.CW_STATE] = cwReducer, _a[AppConstant.reduxResources.COURSES_STATE] = coursesReducer, _a[AppConstant.reduxResources.LANGUAGE_STATE] = languageReducer, _a[AppConstant.reduxResources.HAD_STATE] = hadReducer, _a[AppConstant.reduxResources.EHR_STATE] = ehrReducer, _a[AppConstant.reduxResources.SH_STATE] = shReducer, _a[AppConstant.reduxResources.PS_STATE] = psReducer, _a[AppConstant.reduxResources.HESI_NG_STATE] = hesiNgReducer, _a[AppConstant.reduxResources.DP_STATE] = dpReducer, _a[AppConstant.reduxResources.TOAST_STATE] = toastReducer, _a)));
};
var actionTypesWhitelist = [
    '@@router/LOCATION_CHANGE',
    'APP/SET_EVOLVE_USER_LOADING',
    'APP/SET_SELECTED_COURSE',
    'HESI/SET_PROGRAM_ID',
    'FILTER/RESET_STATE',
    'FILTER/SET_HAD_COHORT_STUDENT_TABLE_ROWS_STATE',
    'FILTER/SET_HAD_COHORT_STUDENT_TABLE_SEARCH',
    'HAD/SET_CATEGORY_GROUP_SELECTED_KEY',
    'SH/SET_STUDENT_AVERAGE_PERFORMANCE_TYPE',
    'PS/SET_SELECTED_EXAM_MIXED_ID',
    'PS/SET_SELECTED_PROGRAM_ID',
    'APP/SET_IS_ALL_AA_DATA_COLLECTED',
    'CW/SET_ASSIGNMENT_SUMMARY_CARD_AND_TABLE_SORT_INTERACTION',
    'DP/SET_USER_PREFERENCES'
];
var addDataToIndexedDB = function (stateStr) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        data = { value: stateStr };
        addUpdateData(data).catch(function (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
        });
        return [2 /*return*/];
    });
}); };
var storageMiddleware = function (_a) {
    var getState = _a.getState;
    return function (next) {
        return function (action) {
            var _a, _b, _c;
            var result = next(action);
            var allState = getState();
            var userId = (_b = (_a = allState === null || allState === void 0 ? void 0 : allState.appState) === null || _a === void 0 ? void 0 : _a.userId) !== null && _b !== void 0 ? _b : (_c = allState === null || allState === void 0 ? void 0 : allState.appState) === null || _c === void 0 ? void 0 : _c.loggedInUser;
            if (actionTypesWhitelist.includes(action.type) && userId) {
                try {
                    addDataToIndexedDB(allState);
                }
                catch (error) {
                    // eslint-disable-next-line no-console
                    console.error(error);
                }
            }
            return result;
        };
    };
};
// Function to get the list of actions required to collect AA data based on the current route
export var getActionsToCollectAAData = function () {
    var actionsToCollectAAData = ['APP/SET_USER_ID', 'APP/SET_USER_ROLE'];
    var locationsHash = window.location.hash.toLowerCase();
    if (locationsHash === "#".concat(SH_PATHS.dashboard.toLowerCase()) || locationsHash === "#".concat(SH_PATHS.cpra.toLowerCase())) {
        actionsToCollectAAData.push('SH/SET_INSTRUCTOR_ID');
    }
    else if (Object.values(HAD_PATHS).some(function (path) { return locationsHash === "#".concat(path.toLowerCase()); })) {
        actionsToCollectAAData.push('APP/SET_LOGGED_IN_USER');
    }
    else {
        actionsToCollectAAData.push('APP/SET_EVOLVE_USER', 'COURSE/SET_COURSE_SECTION_INFO', 'APP/SET_EVOLVE_USER_LOADING', 'APP/SET_FEATURE_FLAGS', 'APP/SET_LOGGED_IN_USER');
    }
    return actionsToCollectAAData;
};
// Middleware to track dispatched actions and update state when all required actions are dispatched
export var allActionsDispatchedMiddleware = function (store) {
    var allDispatchedActions = [];
    return function (next) { return function (action) {
        var _a, _b;
        // Prevent middleware from running if the action is to set isAllAADataCollected
        if (action.type === 'APP/SET_IS_ALL_AA_DATA_COLLECTED') {
            return next(action);
        }
        // Add action to allDispatchedActions if not already included
        if (!allDispatchedActions.includes(action.type)) {
            allDispatchedActions.push(action.type);
        }
        var actionsToCollectAAData = getActionsToCollectAAData();
        // Check if all required actions have been dispatched
        var isAllDataCollected = actionsToCollectAAData.every(function (actionType) { return allDispatchedActions.includes(actionType); });
        // Update state if all data is collected and state does not reflect this
        if (isAllDataCollected) {
            var isAllAADataCollected = (_b = (_a = store === null || store === void 0 ? void 0 : store.getState()) === null || _a === void 0 ? void 0 : _a.app) === null || _b === void 0 ? void 0 : _b.isAllAADataCollected;
            if (!isAllAADataCollected) {
                store.dispatch(appActions.setIsAllAADataCollected(true));
            }
        }
        return next(action);
    }; };
};
var configureStore = function (history) {
    var middlewares = [thunkMiddleware, routerMiddleware(history), storageMiddleware, allActionsDispatchedMiddleware];
    if (process.env.NODE_ENV === 'development') {
        middlewares.push(createLogger({ collapsed: true }));
    }
    var enhancers = [applyMiddleware.apply(void 0, middlewares)];
    /* eslint-disable no-underscore-dangle */
    var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    return createStore(createDefaultReducers(history), {}, composeEnhancers.apply(void 0, enhancers));
};
export { addDataToIndexedDB, AppConstant, configureStore };
